export const tonKho = {
  title: '库存',
  tabs: {
    list: '库存明细',
    stats: '中越汇总',
  },
  fields: {
    batchCode: '批次号',
    customerCode: '客户代码',
    customerName: '客户',
    productName: '商品',
    qty: '库存数量',
    unit: '单位',
    warehouseCode: '仓库代码',
    warehouseName: '仓库',
    weight: '重量',
    volume: '体积',
    note: '备注',
  },
  filter: {
    searchPlaceholder: '搜索...',
    viewMode: '显示方式',
    warehouseId: '仓库 ID（可选）',
  },
  viewMode: {
    byBatch: '按批次明细',
    byCustomer: '按客户汇总',
  },
  actions: {
    exportExcel: '导出 Excel',
  },
  stats: {
    overview: '总览',
    vn: '越南',
    tq: '中国',
    other: '其他',
    metrics: {
      tongSoLo: '总批次数',
      tongSoKien: '总件数',
      tongTrongLuong: '总重量 (kg)',
      tongTheTich: '总体积 (cm³)',
      soLo: '批次数',
      soKien: '件数',
      trongLuong: '重量 (kg)',
      theTich: '体积 (cm³)',
    },
  },
  messages: {
    noData: '暂无数据',
    noStats: '暂无统计数据',
  },
}
